/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
// import { md3 } from 'vuetify/blueprints'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // blueprint: md3,
  components: {
    // ...components,
    ...labsComponents,
  },
  theme: {
    defaultTheme: 'dark',
    themes: {
      light: {
        colors: {
          primary: '#1565C0',
          secondary: '#5CBBF6',
        },
      },
    },
  },

  defaults: {
    VBtn: {
      class: 'text-uppercase',
      size: 'large'
    },
  },
})
